import { notifyInfo, notifyWarning } from "@js/components/notify";

export function initContactImportExport() {
  const bootstrap = window.bootstrap;

  /* =========================================================================
       EXPORT LOGIK
       ========================================================================= */
  const btnExportContact = document.getElementById("btn-export-contact");
  const exportModalElement = document.getElementById("exportContactModal");
  let exportModal;

  if (exportModalElement && bootstrap) {
    exportModal = new bootstrap.Modal(exportModalElement);
  }

  if (btnExportContact && exportModal) {
    btnExportContact.addEventListener("click", () => {
      const checkedBoxes = document.querySelectorAll(".contact-check:checked");
      const contactIds = Array.from(checkedBoxes).map((cb) => cb.getAttribute("data-id"));

      if (contactIds.length === 0) {
        notifyInfo("Bitte wählen Sie mindestens einen Kontakt für den Export aus.", "Hinweis");
        return;
      }

      document.getElementById("exportContactIds").value = contactIds.join(",");
      document.getElementById("exportContactCount").textContent = contactIds.length;

      exportModal.show();
    });
  }

  const availableFields = document.getElementById("availableFields");
  const exportFields = document.getElementById("exportFields");
  const btnMoveRight = document.getElementById("btn-move-right");
  const btnMoveLeft = document.getElementById("btn-move-left");
  const exportForm = document.getElementById("exportContactForm");

  if (btnMoveRight && availableFields && exportFields) {
    btnMoveRight.addEventListener("click", () => {
      const selectedOptions = Array.from(availableFields.selectedOptions);
      selectedOptions.forEach((option) => {
        exportFields.appendChild(option);
      });
    });
  }

  if (btnMoveLeft && availableFields && exportFields) {
    btnMoveLeft.addEventListener("click", () => {
      const selectedOptions = Array.from(exportFields.selectedOptions);
      selectedOptions.forEach((option) => {
        availableFields.appendChild(option);
      });
    });
  }

  if (exportForm) {
    exportForm.addEventListener("submit", (e) => {
      if (exportFields.options.length === 0) {
        e.preventDefault();
        notifyWarning("Bitte wählen Sie mindestens ein Feld für den Export aus.");
        return;
      }
      Array.from(exportFields.options).forEach((opt) => {
        opt.selected = true;
      });

      if (exportModal) {
        setTimeout(() => {
          exportModal.hide();
        }, 100);
      }
    });
  }

  /* =========================================================================
       IMPORT LOGIK
       ========================================================================= */
  const btnImportContact = document.getElementById("btn-import-contact");
  const importModalElement = document.getElementById("importContactModal");
  let importModal;

  if (importModalElement && bootstrap) {
    importModal = new bootstrap.Modal(importModalElement);
  }

  if (btnImportContact && importModal) {
    btnImportContact.addEventListener("click", () => {
      importModal.show();
    });
  }

  const csvFileInput = document.getElementById("csvFileInput");
  const importDelimiterSelect = document.getElementById("importDelimiter");
  const mappingSection = document.getElementById("mappingSection");
  const mappingTableBody = document.querySelector("#mappingTable tbody");
  const btnSubmitImport = document.getElementById("btn-submit-import");

  const availableContactFields = [
    { value: "", label: "-- Bitte wählen --" },
    { value: "name", label: "Vor- und Nachname (kombiniert)" },
    { value: "vorname", label: "Vorname" },
    { value: "nachname", label: "Nachname" },
    { value: "email", label: "E-Mail" },
    { value: "telefon", label: "Telefon" },
    { value: "geburtsdatum", label: "Geburtsdatum" },
    { value: "adresse.strasse", label: "Strasse" },
    { value: "adresse.plz", label: "PLZ" },
    { value: "adresse.ort", label: "Ort" },
    { value: "referenz", label: "Herkunft" },
  ];

  function handleFileParsing() {
    if (!csvFileInput || !csvFileInput.files || csvFileInput.files.length === 0) {
      if (mappingSection) mappingSection.classList.add("d-none");
      if (btnSubmitImport) btnSubmitImport.disabled = true;
      return;
    }

    const file = csvFileInput.files[0];
    const reader = new FileReader();

    reader.onload = function (event) {
      const text = event.target.result;
      const lines = text.split(/\r?\n/);
      if (lines.length > 0) {
        let delimiter = importDelimiterSelect ? importDelimiterSelect.value : ";";
        let headerLine = lines[0];
        if (delimiter === "\\t" || delimiter === "\t") {
          delimiter = "\t";
        }
        const headers = headerLine.split(delimiter).map((h) => h.trim().replace(/^"|"$/g, ""));
        renderMappingTable(headers);
      }
    };
    reader.readAsText(file);
  }

  if (csvFileInput) {
    csvFileInput.addEventListener("change", handleFileParsing);
  }

  if (importDelimiterSelect) {
    importDelimiterSelect.addEventListener("change", handleFileParsing);
  }

  function renderMappingTable(headers) {
    if (!mappingTableBody) return;
    mappingTableBody.innerHTML = "";

    headers.forEach((header, index) => {
      const cleanHeader = header || `Spalte ${index + 1}`;
      const tr = document.createElement("tr");

      const tdCsv = document.createElement("td");
      tdCsv.textContent = cleanHeader;
      tdCsv.className = "align-middle fw-bold";

      const tdSelect = document.createElement("td");
      const select = document.createElement("select");
      select.className = "form-select";
      select.name = `mapping[${cleanHeader}]`;

      availableContactFields.forEach((field) => {
        const option = document.createElement("option");
        option.value = field.value;
        option.textContent = field.label;

        const lowerHead = cleanHeader.toLowerCase();
        const lowerVal = field.value.toLowerCase();

        if (lowerVal === lowerHead) {
          option.selected = true;
        } else if (lowerHead.includes("mail") && field.value === "email") {
          option.selected = true;
        } else if (
          lowerHead.includes("name") &&
          field.value === "nachname" &&
          !lowerHead.includes("vor")
        ) {
          option.selected = true;
        } else if (lowerHead.includes("vorname") && field.value === "vorname") {
          option.selected = true;
        }

        select.appendChild(option);
      });

      tdSelect.appendChild(select);
      tr.appendChild(tdCsv);
      tr.appendChild(tdSelect);
      mappingTableBody.appendChild(tr);
    });

    if (mappingSection) mappingSection.classList.remove("d-none");
    if (btnSubmitImport) btnSubmitImport.disabled = false;
  }
}
